import React from 'react';
import { smsIcon, whatsAppIcon } from '../Icons';

export const DebitTypeObj: {
    [k: string]: { text: string; icon: JSX.Element };
} = {
    sms: {
        text: 'SMS',
        icon: smsIcon('w-18 h-16 fill-darwin-neutral_new-800'),
    },
    wa: {
        text: 'Whatsapp',
        icon: whatsAppIcon('w-18 h-18 fill-darwin-neutral_new-800'),
    },
};

export const RupeeIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className ?? 'w-10 h-12 fill-darwin-neutral_new-800'}
        viewBox="0 0 10 12"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M0.9375 1.04688C0.9375 0.716797 1.19141 0.4375 1.54688 0.4375H3.57812H8.45312C8.7832 0.4375 9.0625 0.716797 9.0625 1.04688C9.0625 1.40234 8.7832 1.65625 8.45312 1.65625H6.29492C6.75195 2.16406 7.05664 2.79883 7.18359 3.48438H8.45312C8.7832 3.48438 9.0625 3.76367 9.0625 4.09375C9.0625 4.44922 8.7832 4.70312 8.45312 4.70312H7.18359C6.87891 6.45508 5.38086 7.75 3.57812 7.75H3.42578L7.56445 10.7207C7.84375 10.9238 7.91992 11.3047 7.7168 11.5586C7.51367 11.8379 7.13281 11.9141 6.87891 11.7109L1.19141 7.64844C0.962891 7.49609 0.886719 7.2168 0.962891 6.96289C1.03906 6.70898 1.26758 6.53125 1.54688 6.53125H3.57812C4.69531 6.53125 5.66016 5.76953 5.93945 4.70312H1.54688C1.19141 4.70312 0.9375 4.44922 0.9375 4.09375C0.9375 3.76367 1.19141 3.48438 1.54688 3.48438H5.93945C5.66016 2.44336 4.69531 1.65625 3.57812 1.65625H1.54688C1.19141 1.65625 0.9375 1.40234 0.9375 1.04688Z" />
    </svg>
);
